/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SsoSamlManagerSamlAction$Params {
      body?: {
'SAMLResponse'?: string | null;
'RelayState'?: string | null;
}
}

export function ssoSamlManagerSamlAction(http: HttpClient, rootUrl: string, params?: SsoSamlManagerSamlAction$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, ssoSamlManagerSamlAction.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

ssoSamlManagerSamlAction.PATH = '/SAMLManager/SamlAction';
